import React from 'react';
import { LegalLayout } from './LegalLayout';
import { THtml } from '../../components/Translate';

const COOKIES_HTML = `
<p>Esta Política de Cookies explica qué son las cookies, qué tipos utilizamos en <strong>PlanCity</strong> y cómo puedes administrarlas. Se complementa con nuestra <a href="/privacidad">Política de Privacidad</a>.</p>

<h2>1. ¿Qué son las cookies?</h2>
<p>Las cookies son pequeños archivos de texto que un sitio web guarda en tu dispositivo (computador, celular o tablet) cuando lo visitas. Permiten recordar información sobre tu navegación, preferencias e inicio de sesión.</p>

<h2>2. Cookies que utilizamos</h2>

<h3>Cookies estrictamente necesarias</h3>
<p>Imprescindibles para que la Plataforma funcione. No requieren consentimiento.</p>
<ul>
  <li><code>token</code> — guarda tu sesión iniciada (almacenamiento local).</li>
  <li><code>plancity_theme</code> — recuerda si elegiste modo claro u oscuro.</li>
  <li><code>plancity_territory</code> — recuerda la comuna/región que seleccionaste.</li>
</ul>

<h3>Cookies de preferencias</h3>
<p>Mejoran tu experiencia pero no son imprescindibles.</p>
<ul>
  <li><code>plancity_hero_images</code> — cachea imágenes del hero para cargas más rápidas.</li>
  <li><code>locale</code> / <code>currency</code> — recuerdan el idioma y la moneda elegida.</li>
</ul>

<h3>Cookies analíticas (si están activas)</h3>
<p>Pueden ser utilizadas en el futuro para entender de forma agregada cómo se usa la Plataforma y mejorarla. Si se activan, te lo informaremos en un banner de consentimiento y podrás aceptarlas o rechazarlas.</p>

<h2>3. Cómo administrarlas</h2>
<p>Puedes aceptar, rechazar o eliminar cookies desde la configuración de tu navegador. Si rechazas cookies necesarias, ciertas funciones (como mantener tu sesión o tu comuna favorita) pueden no funcionar correctamente.</p>
<p>Enlaces útiles según tu navegador:</p>
<ul>
  <li>Chrome: <em>Configuración → Privacidad y seguridad → Cookies y otros datos de sitios</em></li>
  <li>Firefox: <em>Preferencias → Privacidad y Seguridad → Cookies y datos del sitio</em></li>
  <li>Safari: <em>Preferencias → Privacidad → Gestionar datos de sitios web</em></li>
  <li>Edge: <em>Configuración → Cookies y permisos de sitio</em></li>
</ul>

<h2>4. Cambios a esta política</h2>
<p>Si modificamos nuestras prácticas de cookies, actualizaremos esta página y, si corresponde, te pediremos un nuevo consentimiento.</p>

<h2>5. Contacto</h2>
<p>Consultas sobre cookies: usa nuestro <a href="/contacto">formulario de contacto</a>.</p>
`;

export const Cookies = () => {
  return (
    <LegalLayout
      title="Política de Cookies"
      lastUpdated="18 de mayo de 2026"
      path="/cookies"
      description="Política de Cookies de PlanCity. Cómo usamos cookies y tecnologías similares para mejorar tu experiencia."
    >
      <THtml html={COOKIES_HTML} />
    </LegalLayout>
  );
};

export default Cookies;
